/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import * as ToastPrimitives from '@radix-ui/react-toast'
import * as React from 'react'
import { MdOutlineClose } from 'react-icons/md'

import { cn } from '@/utils/css'

const ToastClose = React.forwardRef<
  React.ElementRef<typeof ToastPrimitives.Close>,
  React.ComponentPropsWithoutRef<typeof ToastPrimitives.Close>
>(({ className, ...props }, ref) => (
  <ToastPrimitives.Close
    ref={ref}
    className={cn(
      'absolute right-1 top-1 rounded-md p-1 text-graphite-900/50 opacity-0 transition-opacity hover:text-graphite-900 hover:cursor-pointer focus:opacity-100 focus:outline-none focus:ring-1 group-hover:opacity-100',
      'group-[.destructive]:text-danger-300/50 group-[.destructive]:hover:text-danger-300 group-[.destructive]:focus:ring-danger-500 group-[.destructive]:focus:ring-offset-danger-800',
      className,
    )}
    toast-close=''
    {...props}
  >
    <MdOutlineClose className={'h-4 w-4'} />
  </ToastPrimitives.Close>
))
ToastClose.displayName = ToastPrimitives.Close.displayName

export { ToastClose }
